import clx from 'classnames'
import Table from '../Table'
import styles from './RankingTable.css'
import { pullLeft } from '../../../../../styles/shared.css'
import FilledRanking from '../../../FilledRanking/FilledRanking'

const getColumnsWithRanking = (columns, rankingColumnProps = {}) => {
  const {
    rankingSize = 5,
    startIndex = 0,
    ...restProps
  } = rankingColumnProps
  const ranking = {
    id: 'ranking',
    accessor: 'ranking',
    headerClassName: clx(pullLeft, styles.termHeader),
    className: clx(pullLeft, styles.termHeader),
    width: 30,
    Header: '排行',
    Cell: row => {
      const { index } = row
      const currentIndex = startIndex + index
      const filled = currentIndex < rankingSize
      return (
        <FilledRanking
          className={styles.ranking}
          filled={filled}
          value={currentIndex + 1}
        />
      )
    },
    ...restProps
  }
  return [ranking, ...columns]
}

const RankingTable = ({ columns, rankingColumnProps, ...props }) => {
  const rankingColumns = getColumnsWithRanking(columns, rankingColumnProps)
  return (
    <Table
      columns={rankingColumns}
      {...props}
    />
  )
}

export default RankingTable
